import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
    const { isAuthenticated, token, logout } = useAuth();
    const location = useLocation();

    const [checking, setChecking] = useState(true);
    const [allowed, setAllowed] = useState(false);

    useEffect(() => {
        let ignore = false;

        const validateToken = async () => {
            // Not logged in → immediate redirect
            if (!isAuthenticated || !token) {
                setAllowed(false);
                setChecking(false);
                return;
            }

            setChecking(true);
            try {
                // TODO: replace with your real endpoint
                // Example:
                // const res = await axios.get("/auth/validate", {
                //   headers: { Authorization: `Bearer ${token}` },
                // });

                // DEMO: assume OK
                if (!ignore) {
                    setAllowed(true);
                }
            } catch (err) {
                // Token invalid/expired → logout and block
                logout();
                if (!ignore) {
                    setAllowed(false);
                }
            } finally {
                if (!ignore) setChecking(false);
            }
        };

        validateToken();
        return () => {
            ignore = true;
        };
        // IMPORTANT: re-check on route change (location.key/pathname)
    }, [location.pathname, isAuthenticated, token, logout]);

    if (!isAuthenticated) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    // Optional: nicer UX while verifying
    if (checking) {
        return (
            <div className="min-vh-100 d-flex align-items-center justify-content-center">
                <div className="text-muted">Checking session...</div>
            </div>
        );
    }

    if (!allowed) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    return children;
}
